export default "__VITE_ASSET__DiwtzHXu__"